import React, { useState } from "react";
import styled from "styled-components";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { db } from "../firebase/firebaseConfig"; // ✅ Import Firebase config
import { collection, addDoc, Timestamp } from "firebase/firestore";

const Wrapper = styled.div`
  padding: 4rem 2rem;
  color: white;
  background: #0b0b0b;
  font-family: "Poppins", sans-serif;
  min-height: 100vh;
`;

const Heading = styled.h1`
  font-size: 3rem;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  font-size: 1.1rem;
  color: #ccc;
  margin-bottom: 2rem;
`;

const ContactForm = styled.form`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.8rem;
  font-size: 1rem;
  border-radius: 8px;
  border: none;
  background: #1a1a1a;
  color: white;
  outline: none;
`;

const Textarea = styled.textarea`
  padding: 0.8rem;
  font-size: 1rem;
  border-radius: 8px;
  border: none;
  background: #1a1a1a;
  color: white;
  height: 150px;
  outline: none;
`;

const Button = styled.button`
  background: ${({ theme }) => theme.primary};
  border: none;
  padding: 0.9rem;
  border-radius: 10px;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: ${({ theme }) => theme.secondary};
    color: #fff;
  }
`;

const ContactInfo = styled.div`
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1.1rem;
  color: #ccc;
`;

const IconWrapper = styled.div`
  background: ${({ theme }) => theme.primary};
  color: #000;
  padding: 0.6rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContactUs = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await addDoc(collection(db, "contacts"), {
        name: form.name,
        email: form.email,
        message: form.message,
        createdAt: Timestamp.now(),
      });
      alert("Message sent successfully ✅");
      setForm({ name: "", email: "", message: "" });
    } catch (err) {
      console.error("Error adding contact: ", err);
      alert("Something went wrong ❌");
    }

    setLoading(false);
  };

  return (
    <Wrapper>
      <Heading>Contact Us</Heading>
      <Paragraph>
        Have a question, partnership idea, or want to report an issue? We'd love
        to hear from you!
      </Paragraph>

      <ContactForm onSubmit={handleSubmit}>
        <Input
          type="text"
          name="name"
          placeholder="Your Name"
          value={form.name}
          onChange={handleChange}
          required
        />
        <Input
          type="email"
          name="email"
          placeholder="Your Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <Textarea
          name="message"
          placeholder="Your Message"
          value={form.message}
          onChange={handleChange}
          required
        />
        <Button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Send Message"}
        </Button>
      </ContactForm>

      <ContactInfo>
        {/* <InfoItem>
          <IconWrapper>
            <FaMapMarkerAlt />
          </IconWrapper>
          867, House No., Tulsi Vihar Colony, Dadri - 203207, Uttar Pradesh,
          India
        </InfoItem> */}

        <InfoItem>
          <IconWrapper>
            <FaPhoneAlt />
          </IconWrapper>
          +91 8383006681
        </InfoItem>

        <InfoItem>
          <IconWrapper>
            <FaEnvelope />
          </IconWrapper>
          <div>
            <a
              href="mailto:gauravofficial1995@gmail.com"
              style={{ color: "#ccc" }}
            >
              gauravofficial1995@gmail.com
            </a>
            <br />
            <a
              href="mailto:contact@engineercodewala.in"
              style={{ color: "#ccc" }}
            >
              contact@engineercodewala.in
            </a>
          </div>
        </InfoItem>
      </ContactInfo>
    </Wrapper>
  );
};

export default ContactUs;
